import { I18n } from "../../../../Utils/types";
import { AutographLabel } from "./types";

export const TEXTS: Record<AutographLabel, I18n> = {
    name: {
        en: "Arch . Amit Korach",
        he: "עמית קורח",
    },
    role: {
        en: "Chief Architect . CEO",
        he: "אדריכל ראשי . מנכ\"ל",
    },
    studioName: {
        en: "Studio Paco",
        he: "סטודיו פאקו",
    },
    studioSlogan: {
        en: "Design . Architecture",
        he: "אדריכלות . עיצוב",
    }
};